import MappingMixin from "@/mixins/mappingMixin";
import {
  getGenerateFeaturesRequestOptions,
  generateGraphics
} from "./importLogic";
import { getUniqueLayerID } from "./layerLogic";
const importMixin = {
  mixins: [MappingMixin],
  data: function() {
    return {};
  },
  methods: {
    importFeaturesFromGISFileAndAddAsLayer(file) {
      return new Promise((resolve, reject) => {
        getGenerateFeaturesRequestOptions(file)
          .then(requestOptions => {
            generateGraphics({
              name: file.name,
              requestOptions: requestOptions
            }).then(graphics => {
              this.addMapProfile({
                id: getUniqueLayerID(),
                graphics: graphics,
                appTitle: file.name
              }).then(result => {
                resolve(result);
              });
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default importMixin;
